import { Product } from "../../../../data/models"
import { BaseModel } from "../../../models"

export class ProductRegistration extends BaseModel {
  public activeAt: Date
  public inactiveAt: Date
  public createdAt: Date
  public product: Product

  constructor() { super() }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/product-registration/product-registration.ts